import { ArrowRight } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

const CONSULTANT_IMG =
  "https://customer-assets.emergentagent.com/job_impact-platform-demo/artifacts/rzs1vwsq_1.jpg";

export const ImpactStats = () => {
  const { t } = useLanguage();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="impact"
      data-testid="impact-stats-section"
      className="relative bg-[#F3F4F5] text-[#181B24] pb-16 md:pb-20 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          <div className="lg:col-span-5">
            <h2
              data-testid="impact-headline"
              className="font-heading uppercase font-bold leading-[0.98] tracking-[0.01em] text-4xl sm:text-5xl md:text-6xl lg:text-[4.5rem]"
            >
              {t.impact.headlineLines.map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
              <span className="gradient-text">{t.impact.headlineAccent}</span>
            </h2>

            <p
              data-testid="impact-paragraph"
              className="mt-8 text-[#181B24]/75 text-base md:text-lg leading-relaxed font-body max-w-md"
            >
              {t.impact.paragraph}
            </p>

            <button
              data-testid="impact-cta-button"
              onClick={() => scrollTo("contact")}
              className="mt-10 group inline-flex items-center gap-3 rounded-full gradient-bg text-[#181B24] font-heading font-bold uppercase tracking-[0.15em] text-sm px-8 py-4 hover-lift shadow-[0_10px_30px_rgba(255,226,26,0.2)]"
            >
              {t.impact.cta}
              <ArrowRight
                size={18}
                className="group-hover:translate-x-1 transition-transform"
              />
            </button>
          </div>

          <div className="lg:col-span-3 flex flex-col gap-4">
            {t.impact.stats.map((s, i) => (
              <div
                key={s.label}
                data-testid={`stat-pill-${i}`}
                className={`bg-[#202535] text-white p-6 md:p-7 ${
                  i % 2 === 0
                    ? "rounded-tl-[2.5rem] rounded-br-[2.5rem] rounded-tr-md rounded-bl-md"
                    : "rounded-tr-[2.5rem] rounded-bl-[2.5rem] rounded-tl-md rounded-br-md"
                }`}
              >
                <div className="font-heading gradient-text text-4xl md:text-5xl font-bold leading-none">
                  {s.value}
                </div>
                <div className="mt-3 text-white/85 text-sm md:text-[0.95rem] font-body">
                  {s.label}
                </div>
              </div>
            ))}
          </div>

          <div className="lg:col-span-4">
            <div className="relative aspect-[3/4] md:aspect-[4/5] lg:aspect-auto lg:h-[700px] rounded-[2rem] overflow-hidden bg-[#E5E7EB]">
              <img
                src={CONSULTANT_IMG}
                alt="Martin — IT consultant and mentor"
                className="w-full h-full object-cover"
                style={{ objectPosition: "50% 25%" }}
                loading="lazy"
                data-testid="impact-consultant-image"
              />
              <div className="absolute top-4 right-4 w-3 h-3 rounded-full bg-[#FFE21A]" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactStats;
